<template>
  <div class="create-reference">
    <div class="row">
      <div class="col-sm-12">
        <div>
          <mu-text-field v-model="reference.name" label="Namn" />
        </div>
        <div>
          <mu-text-field v-model="reference.text" label="Text" labelFloat :fullWidth="true"/>
        </div>
      </div>
      <div class="col-sm-12">
        <mu-raised-button v-if="!isUpdate" class="demo-raised-button" label="Lägg till" icon="add" primary @click="createReference"/>
        <mu-raised-button v-if="isUpdate" class="demo-raised-button" label="Uppdatera" icon="add" primary @click="createReference"/>
        <mu-raised-button class="demo-raised-button" label="Ta bort" icon="delete" @click="deleteReference"/>
        <mu-raised-button class="demo-raised-button" label="Avbryt" icon="cancel" @click="closeDialog"/>
      </div>
    </div>
  </div>
</template>

<script>
import { createReference, updateReference, deleteReference } from '../store/actions'

export default {
  name: 'CreateReference',
  props: {
    editReference: {
      type: Object
    }
  },
  data () {
    return {
      reference: {
        name: '',
        text: ''
      }
    }
  },
  mounted () {
    if (this.editReference) {
      this.reference = JSON.parse(JSON.stringify(this.editReference))
    }
  },
  computed: {
    isUpdate () {
      return this.reference.id
    }
  },
  methods: {
    createReference () {
      if (!this.reference.id) {
        createReference(this.$store, this.reference).then(() => {
          this.closeDialog()
        })
      } else {
        updateReference(this.$store, this.reference).then(() => {
          this.closeDialog()
        })
      }
    },
    deleteReference () {
      deleteReference(this.$store, this.reference).then(() => {
        this.closeDialog()
      })
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-reference {
   
}
</style>
